module.exports = __webpack_public_path__ + "static/media/medic.9852cf3c.jpg";